enum SettingsName {
  PARTICIPANT = 'participant-table-settings'
}

export default SettingsName;
